import { Row, Card } from 'antd'
import { EmptyHeaderHero, SEO } from './components'

import SecurityStyle from '../../styles/SecurityPolicy.module.css'

const SecurityPolicy = () => {
  return (
    <>
      <SEO
        title={"Security Policy | CURE Auto Insurance"} 
        description={"Review CURE auto insurance’s Security Policy. Learn how we safeguard your personal data with strict measures to ensure protection, privacy, and trust."} 
        url={"/security-policy"}
      />
      <EmptyHeaderHero title="Security Statement" />
      <div className={`${SecurityStyle["security-statement-screen"]}`}>
        <Row>
          <Card className={`${SecurityStyle["security-statement-card"]}`}>
            <h5>Overall Security Statement:</h5>
            <p>
              CURE is committed to safeguarding your security. In order to protect the information you submit to our
              website and ensure that it remains confidential, we use industry-standard hardware and software in
              combination with authentication and certification by third parties to protect the transmission of data,
              the processing of data, and the storing of data.
            </p>
            <h5>TLS/SSL Data Transmission:</h5>
            <p>
              SSL refers to Secure Sockets Layer whereas TLS refers to Transport Layer Security. SSL and TLS are
              cryptographic protocols that authenticate data transfers between servers, systems, applications and users.
              For example, a cryptographic protocol encrypts the data that is exchanged between a web server and a user.
            </p>
            <h5>Firewall Technology:</h5>
            <p>
              Firewall technology is another layer of protection that prevents unauthorized access to or from a private
              network when connected to the Internet. All data entering or leaving the network must pass through
              CURE&apos;s firewall, which examines each message and blocks those that do not meet our specified security
              criteria.
            </p>
            <h5>The Storage of Your Information:</h5>
            <p>
              Our dedicated hosting data centers are physically isolated from everyone but senior technicians. Monitored
              closed circuit television and 24x7 onsite security personnel guard the facility while military-grade pass
              card access and biometric hand scan units provide further layers of security.
            </p>
            <hr />
            <p className={`${SecurityStyle["security-statement-foot-note"]}`}>Version Date: March 31, 2022</p>
          </Card>
        </Row>
      </div>
    </>
  )
}

SecurityPolicy.propTypes = {}

export default SecurityPolicy
